import { Route } from 'react-router-dom';
import Validacion from './Wallet';
import ListarCreditoOperadores from './Listar-Credito-Operadores';
import ListarCreditoActivo from './Listar-Credito-Activo';

const WalletRouter = (
  <Route path="wallet" element={<Validacion />}>
    <Route path="promotores" element={<ListarCreditoOperadores />} />
    <Route path="creditos" element={<ListarCreditoActivo />} />
  </Route>
);

export default WalletRouter;
